import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeListModule } from 'se-fe-list'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SeFeSwitchModule } from 'se-fe-switch'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTooltipModule } from 'se-fe-tooltip'
import { AffiliationAccessComponent } from './affiliation-access/affiliation-access.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAvatarModule,
    SeFeCardModule,
    SeFeHeaderModule,
    SeFeListModule,
    SeFeSpinnerModule,
    SeFeSwitchModule,
    SeFeToastModule,
    SeFeTooltipModule
  ],
  declarations: [
    AffiliationAccessComponent
  ],
  exports: [
    AffiliationAccessComponent
  ]
})
export class SharedFeatureAffiliationAccessModule {}
